import React from 'react';
import { motion } from 'framer-motion';
import { FileX, Truck, Camera, Package } from 'lucide-react';
const failures = [{
  icon: FileX,
  title: 'Trabajos Remotos Tradicionales',
  description: 'Buscar trabajos remotos tradicionales que te piden papeles o SSN que quizás no tienes listos.'
}, {
  icon: Truck,
  title: 'Entregas y Transporte',
  description: 'Intentar modelos de negocio que requieren que entregues paquetes o te muevas por la ciudad.'
}, {
  icon: Camera,
  title: 'El Mito del Influencer',
  description: "Seguir consejos de 'influencers' que no entienden lo que es vivir con el miedo a la deportación y te piden que te expongas en cámara."
}, {
  icon: Package,
  title: 'Venta de Productos Físicos',
  description: 'Tratar de vender productos que requieren inventario físico en tu casa, aumentando tu perfil de riesgo.'
}];
export function WhyDidntWork() {
  return <section className="bg-[#0a0a0a] py-20" data-id="element-184">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-185">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-186">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-187">
            Por qué lo que intentaste antes no funcionó para alguien como tú.
          </h2>
          <div className="w-24 h-1 bg-[#d4a437] mx-auto rounded-full opacity-50" data-id="element-188"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-189">
          {failures.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-[#111] border border-white/5 rounded-xl p-6 hover:border-[#d4a437]/30 transition-colors group" data-id="element-190">
              <div className="w-12 h-12 rounded-lg bg-neutral-900 flex items-center justify-center mb-4 group-hover:bg-[#d4a437]/10 transition-colors" data-id="element-191">
                <item.icon className="w-6 h-6 text-neutral-400 group-hover:text-[#d4a437] transition-colors" data-id="element-192" />
              </div>
              <h3 className="text-xl font-semibold text-white mb-3" data-id="element-193">
                {item.title}
              </h3>
              <p className="text-neutral-400 leading-relaxed" data-id="element-194">
                {item.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}